import { apiEndpoints } from '../constants/links';
import { SingleMedia } from '../types/strapi.types';

export const getFileLink = (file?: SingleMedia) => {
  if (!file?.data?.attributes) return '';

  return `/${apiEndpoints.files}/${file.data?.attributes?.hash}${file.data?.attributes?.ext}`;
};